import axios from 'axios'
import * as types from '../mutation-types'
import { kSort } from '../../plugins/helper'

const doToArrayObject = (organizationalRoleType) => {
  const term = []
  Object.keys(organizationalRoleType).forEach(key => {
    term.push({
      value: organizationalRoleType[key].id,
      text: organizationalRoleType[key].name,
    })
  })

  return term
}

const doToArrayObjectTypeUser = (data, excludeId) => {
  let term = []
  Object.keys(data).forEach(index => {
    const currentUserId = excludeId ? excludeId.toString() : excludeId
    if (currentUserId !== index) {
      term.push({
        value: index,
        text: data[index],
      })
    }
  })

  const users = kSort(term, 'text')

  return users
}

// state
export const state = {
  loading: true,
  organizationalRoleType: [],
  error: null,
  loadingSalesProcessors: true,
  salesProcessors: [],
  errorSalesProcessors: null,
}

// mutations
export const mutations = {
  [types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_START] (state) {
    state.loading = true
    state.organizationalRoleType = []
    state.error = null
  },

  [types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_SUCCESS] (state, { data }) {
    state.loading = false
    state.organizationalRoleType = doToArrayObject(data)
    state.error = null
  },

  [types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_ERROR] (state, { error }) {
    state.loading = false
    state.organizationalRoleType = []
    state.error = error
  },

  [types.GET_SALES_PROCESSORS_START] (state) {
    state.loadingSalesProcessors = true
    state.salesProcessors = []
    state.errorSalesProcessors = null
  },

  [types.GET_SALES_PROCESSORS_SUCCESS] (state, { data, excludeId }) {
    state.loadingSalesProcessors = true
    state.salesProcessors = doToArrayObjectTypeUser(data, excludeId)
    state.errorSalesProcessors = null
  },

  [types.GET_SALES_PROCESSORS_ERROR] (state, { error }) {
    state.loadingSalesProcessors = true
    state.salesProcessors = []
    state.errorSalesProcessors = error
  },
}

export const actions = {
  async getOrganizationalRoleType ({ commit }) {
    try {
      commit(types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_START)

      const { data } = await axios.get('/api/organizational_role_type/lists')

      commit(types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_SUCCESS, { data: data })
    } catch (e) {
      commit(types.GET_LIST_ORGANIZATIONAL_ROLE_TYPE_ERROR, { error: e })
    }
  },
  async getSalesProcessors ({ commit }, { organizationalRoleType, excludeId = 0 }) {
    try {
      commit(types.GET_SALES_PROCESSORS_START)

      const { data } = await axios.get(`/api/organizational_role_type/listUsers/${organizationalRoleType}`)

      commit(types.GET_SALES_PROCESSORS_SUCCESS, { data, excludeId })
    } catch (e) {
      commit(types.GET_SALES_PROCESSORS_ERROR, { error: e })
    }
  },
}

// getters
export const getters = {
  loadingOrganizationalRoleType: state => state.loading,
  organizationalRoleType: state => state.organizationalRoleType,
  errorOrganizationalRoleType: state => state.error,
  loadingSalesProcessors: state => state.loadingSalesProcessors,
  salesProcessors: state => state.salesProcessors,
  errorSalesProcessors: state => state.errorSalesProcessors,
}
